import { module } from 'modujs'
import { $html } from '../utils/dom';
import LocomotiveScroll from 'locomotive-scroll'

export default class Scroll extends module {

    static MQ_SMOOTH = `(prefers-reduced-motion: no-preference)`;

    constructor(m) {
        super(m);

        // Template 
        this.singleTemplate = $html.dataset.template === 'evenement' ? true : false;

        this.isStopped = false
        this.onScroll = this.onScroll.bind(this)
    }

    init() {
        this.scroll = new LocomotiveScroll({
            modularInstance: this,
            scrollCallback: this.onScroll,
            lenisOptions: {
                smoothWheel: window.matchMedia(Scroll.MQ_SMOOTH).matches
            }
        })

        // Force scroll to top
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual'
            window.scrollTo(0, 0)
        }

        this.scroll.lenisInstance.options.content.addEventListener('wheel', (event) => {
            const targets = event.composedPath();

            const stopPropagation = targets.some(target => target.id === 'cc-main');
            if (stopPropagation) {
                event.stopPropagation();
            }
        });

        this.scrollDirection = 0
    }

    onScroll(event) {
        // Set scroll top
        let scrollTop = $html.dataset.template === 'evenement' ? false : event.scroll < 200

        // Update direction
        // let direction = event.direction

        // if (direction !== 0) {
        //     this.call('setSticky', !scrollTop && direction < 0, 'Header')
        // }

        this.call('setSticky', !scrollTop, 'Header')
        this.call('updateStickyLock', scrollTop, 'Header');
    }

    scrollTo(params) {
        let { target, options } = params
        options = Object.assign({}, options)

        this.scroll?.scrollTo(target, options)
    }

    addScrollElements(container) {
        this.scroll.addScrollElements(container)
    }

    removeScrollElements(container) {
        this.scroll.removeScrollElements(container)
    }

    stop() {
        if (this.isStopped) return

        this.scroll?.lenisInstance.stop()
        this.isStopped = true
    }

    start() {
        if (!this.isStopped) return

        this.scroll?.lenisInstance.start()
        this.isStopped = false
    }

    lazyFrame(params) {
        let { target } = params;
        if (target && target.tagName === 'IFRAME') {
            let dataSrc = target.getAttribute('data-src');
            if (dataSrc) {
                target.setAttribute('src', dataSrc);
                target.removeAttribute('data-src');
            }
        }
    }

    destroy() {
        this.scroll.destroy();
    }
}
